import Confirm from 'assets/components/page/templates/Confirm';
import ThemeConfirmDefault from 'assets/components/page/templates/themes/Theme.Confirm.Default';
import { getLocales } from 'assets/locales/Locale';
import Theme from 'assets/themes/Theme.Common';
import { useClaimJobPaymentProvider } from '../Finance.ClaimJobPayment.Hooks';

const FinanceClaimJobPaymentCancel = () => {
  const { lang } = getLocales();
  const { cancelApi, selected, pageRouter } = useClaimJobPaymentProvider();

  if (!selected) return null;

  return (
    <Confirm
      data={selected}
      onConfirm={({ id }) => cancelApi.execute({ id })}
      onClose={pageRouter.updateParams}
      actionName={lang.cancelPayment}
      itemName={`(ID: ${selected.id})`}
      info={
        <div style={{ fontSize: Theme.FontSize.M }}>
          <p>{lang.areYouSureYouWantToCancelThisPayment}</p>

          <p>{lang.thisPaymentMayHavePendingUsBankPayments}</p>
        </div>
      }
      confirmationType="nextButton"
      subcomponents={ThemeConfirmDefault}
    />
  );
};

export default FinanceClaimJobPaymentCancel;
